var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import LanguageSwitcher from "./LanguageSwitcher";
var Navigation = /** @class */ (function (_super) {
    __extends(Navigation, _super);
    function Navigation(props) {
        var _this = _super.call(this, props) || this;
        _this.changeLanguage = function (key) {
            _this.setState({ isToggleLang: false });
        };
        _this.toggleLang = function (e) {
            _this.setState({ isToggleLang: !_this.state.isToggleLang });
        };
        _this.state = {
            isToggleLang: false,
            langMap: [
                { key: "de", name: "Deutsch" },
                { key: "en", name: "English" },
            ]
        };
        return _this;
    }
    Navigation.prototype.render = function () {
        var _this = this;
        var _a, _b;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'row mainnav-container' },
                React.createElement("div", { className: 'small-12 large-10 large-centered columns' },
                    React.createElement("div", { className: "search-nav right " + (this.state.isToggleLang ? 'active' : '') },
                        React.createElement("a", { className: "search", onClick: function (e) { return _this.toggleLang(e); } },
                            React.createElement("i", { className: this.state.isToggleLang ? 'fi-x' : 'fi-web' }))),
                    React.createElement("div", { className: 'nav-container right hide-for-large-up' }, "\u00A0"),
                    React.createElement("div", { style: { marginRight: '3%' } },
                        React.createElement("nav", { className: 'top-bar mainnav' },
                            React.createElement("ul", { className: 'title-area' },
                                React.createElement("li", { className: 'name' },
                                    React.createElement("a", { href: 'http://www.uni-muenchen.de' },
                                        React.createElement("img", { src: 'https://cms-static.uni-muenchen.de/default/foundation-zuv/sites/login/header-desktop.png', className: 'no-resize show-for-medium-up' })),
                                    React.createElement("h1", { className: 'mainnav-title' },
                                        React.createElement("a", { href: '#' }, "Anmeldung")))),
                            React.createElement("section", { className: 'top-bar-section' }))))),
            React.createElement(LanguageSwitcher, { isToggleLang: (_a = this.state) === null || _a === void 0 ? void 0 : _a.isToggleLang, langMap: (_b = this.state) === null || _b === void 0 ? void 0 : _b.langMap, changeLang: this.changeLanguage })));
    };
    return Navigation;
}(Component));
export default Navigation;
